import React from "react";
import "./style.scss";
const SuperstarItem = ({color,bg,item,callBackHandler,isActive}) => {
  return (
    <button className="superstar-assigned-container" style={{backgroundColor:`var(${isActive?color:bg})`,border:`1px solid var(${isActive?bg:color})`}} onClick={()=>callBackHandler(item?._id)}>
      <div className="user-avator" style={{color:`var(${bg})`}}>{item?.name?.slice(0,2)||""}</div>
      <p className="user-name" style={{color:`var(${isActive?bg:color})`}}>{item?.name||""}</p>
      <p className="count"  style={{color:`var(${isActive?bg:color})`}}>{item?.serviceCompletedCount||0}</p>
    </button>
  );
};

export default SuperstarItem;
